"use client";

import { useSession } from "../../../session/hooks/useSession";
import { useRequestMe } from "./useRequestMe";

export const useIsKidAccount = () => {
  const { jwtPayload, status } = useSession();
  const {
    query: { data, isLoading },
  } = useRequestMe();
  const isKidAccountFromJwt = jwtPayload?.isKidAccount;
  const isKidAccount =
    typeof isKidAccountFromJwt === "boolean"
      ? isKidAccountFromJwt
      : (data?.is_kid ?? false);

  return {
    isKidAccount,
    isLoading:
      status === "loading" ||
      (status === "authenticated" &&
        typeof isKidAccountFromJwt !== "boolean" &&
        isLoading),
  };
};
